import { observable, toJS, computed } from 'mobx';
import axios from 'axios'

class Document {
  
  @observable document = {}
  @observable search_results = []
  
  constructor(){

    this.document = {}
    this.search_results = []
    
  }
  
  fetch = (id) => {
    
    this.document = {}
    
    axios.get('https://holdmyticket.com/api/public/documents/get/'+id)
    .then((response) => {
      var data = response.data
      // data.content_markdown = data.content_markdown.replace(/#/g, '#').replace(/# #/g, '##').replace(/# #/g, '##').replace(/# #/g, '##')
      this.document = data
    })
    .catch(function (error) {
      console.log(error);
    })

  }
  
  search = (query) => {
    
    axios.get('https://holdmyticket.com/api/public/documents/search/'+query)
    .then((response) => {
      this.search_results = response.data.results
    })
    .catch(function (error) {
      console.log(error);
    })
    
  }
  
  @computed get read(){
    return toJS(this.document)
  }
  
  @computed get results(){
    return toJS(this.search_results)
  }

}

export default Document


// WEBPACK FOOTER //
// ./src/stores/document.js